<template>
  <transition name="thread-modal">
    <div v-if="visible" class="thread-modal__backdrop" @click.self="onBackdropClick">
      <div class="thread-modal__dialog">
        <div class="thread-modal__header">
          <slot name="header">
            <ThreadText :type="'h6'">
              {{ title }}
            </ThreadText>
          </slot>
          <button v-if="showClose" type="button" class="thread-modal__close" @click="$emit('close')">&times;</button>
        </div>

        <div class="thread-modal__body">
          <slot />
        </div>

        <div class="thread-modal__footer">
          <slot name="footer">
            <b-button variant="primary" class="thread-modal__submit" :disabled="submitConfig.disabled" @click="$emit('submit')">
              {{ submitConfig.label }}
            </b-button>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ThreadText from "@/components/common/thread-text.vue";

export default {
  name: "ThreadModal",
  components: {
    ThreadText
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeConfig: {
      type: Object,
      default: () => ({ onBackdrop: false, onEsc: true })
    },
    submitConfig: {
      type: Object,
      default: () => ({ label: "Submit", disabled: false })
    }
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onBackdropClick() {
      if (!this.closeConfig.onBackdrop) {
        return;
      }
      this.$emit("close");
    },
    onKeydown(e) {
      if (e.key === "Escape" && !this.closeConfig.onEsc) {
        this.$emit("close");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.thread-modal {
  &__backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1060;
  }

  &__dialog {
    background: #fff;
    border-radius: 4px;
    width: 500px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    font-family: "Roboto", sans-serif;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    flex-shrink: 0;
  }

  &__close {
    background: none;
    border: none;
    font-size: 28px;
    line-height: 1;
    color: #000;
    opacity: 0.5;
    cursor: pointer;
    padding: 0;

    &:hover {
      opacity: 1;
    }
  }

  &__body {
    padding: 0 20px;
    overflow-y: auto;
    flex: 1;
    max-height: 644px;
  }

  &__footer {
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
  }

  &__submit {
    font-size: 14px;
    color: #ffffff;
    background-color: #1e8fe1;
    border-color: #1e8fe1;
  }
}

.thread-modal-enter-active,
.thread-modal-leave-active {
  transition: opacity 0.25s ease;

  .thread-modal__dialog {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
}

.thread-modal-enter,
.thread-modal-leave-to {
  opacity: 0;

  .thread-modal__dialog {
    opacity: 0;
    transform: translateY(-16px);
  }
}
</style>
